// Custom JS to force slideshow button text to white
window.addEventListener('load', function() {
  var buttons = document.querySelectorAll('.section-slideshow a.btn');
  buttons.forEach(function(btn) {
    btn.style.color = '#ffffff';        // Forces white text
    btn.style.transition = 'color 0.3s'; // Smooth transition if hover changes
  });
});
